import React from 'react'
import DonationDetail from './DonationDetail'
import UpCommingDonation from './UpCommingDonation'
import { Link } from 'react-router-dom'

export const DonationDashboard = () => {
  return (
    <>
    <section className='Admindashboard__task__wrapper '>
      <div className='container'>
        <UpCommingDonation/>
        <DonationDetail/>
       
        
      </div>
    </section>
  </>
  )
}
